export const contactTranslations = {
  en: {
    title: 'Contact us',
    subtitle: 'Have questions about AI and automation? We are happy to provide you with free, non-binding consultation.',
    contactSectionTitle: 'Free AI Consultation',
    email: 'info@plix-ai.com',
    bookMeetingButton: 'Book Meeting',
    companyDetailsTitle: 'Company Details',
    workingHoursTitle: 'Working Hours',
    workingHoursText: '8AM - 5PM, Mon to Fri'
  },
  de: {
    title: 'Kontaktieren Sie uns',
    subtitle: 'Haben Sie Fragen zu KI und Automatisierung? Wir beraten Sie gern in einem kostenlosen unverbindlichen Gespräch.',
    contactSectionTitle: 'Kostenlose KI-Beratung',
    email: 'info@plix-ai.com',
    bookMeetingButton: 'Termin buchen',
    companyDetailsTitle: 'Unternehmensdetails',
    workingHoursTitle: 'Arbeitszeiten',
    workingHoursText: '8 - 17 Uhr, Montag bis Freitag'
  }
}; 